module.exports = function (method, arg, inverted) {
  const msgList = inverted ? negativeMessages : positiveMessages;
  return msgList[method] && msgList[method](arg);
};
const positiveMessages = {
  min: num => "The string should have a minimum length of ".concat(num, " character").concat(pluralify(num)),
  max: num => "The string should have a maximum length of ".concat(num, " character").concat(pluralify(num)),
  letters: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return "The string should have a minimum of ".concat(num, " letter").concat(pluralify(num));
  },
  digits: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return "The string should have a minimum of ".concat(num, " digit").concat(pluralify(num));
  },
  uppercase: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return "The string should have a minimum of ".concat(num, " uppercase letter").concat(pluralify(num));
  },
  lowercase: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return "The string should have a minimum of ".concat(num, " lowercase letter").concat(pluralify(num));
  },
  symbols: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return "The string should have a minimum of ".concat(num, " symbol").concat(pluralify(num));
  },
  spaces: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    return "The string should have a minimum of ".concat(num, " space").concat(pluralify(num));
  },
  oneOf: list => "The string should be ".concat(list.length > 1 ? "one of ".concat(list.slice(0, -1).join(', '), " and ") : '').concat(list[list.length - 1]),
  has: pattern => "The string should have pattern '".concat(pattern, "'"),
  not: pattern => "The string should not have pattern '".concat(pattern, "'"),
  usingPlugin: fn => "The string should not violate ".concat(fn.name || 'plugin')
};
const negativeMessages = {
  min: num => "The string should have a maximum length of ".concat(num, " character").concat(pluralify(num)),
  max: num => "The string should have a minimum length of ".concat(num, " character").concat(pluralify(num)),
  letters: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return "The string should ".concat(num === 0 ? 'not have' : "have a maximum of ".concat(num), " letter").concat(pluralify(num));
  },
  digits: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return "The string should ".concat(num === 0 ? 'not have' : "have a maximum of ".concat(num), " digit").concat(pluralify(num));
  },
  uppercase: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return "The string should ".concat(num === 0 ? 'not have' : "have a maximum of ".concat(num), " uppercase letter").concat(pluralify(num));
  },
  lowercase: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return "The string should ".concat(num === 0 ? 'not have' : "have a maximum of ".concat(num), " lowercase letter").concat(pluralify(num));
  },
  symbols: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return "The string should ".concat(num === 0 ? 'not have' : "have a maximum of ".concat(num), " symbol").concat(pluralify(num));
  },
  spaces: function () {
    let num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return "The string should ".concat(num === 0 ? 'not have' : "have a maximum of ".concat(num), " space").concat(pluralify(num));
  },
  oneOf: list => "The string should not be ".concat(list.length > 1 ? "one of ".concat(list.slice(0, -1).join(', '), " and ") : '').concat(list[list.length - 1]),
  has: pattern => "The string should not have pattern '".concat(pattern, "'"),
  not: pattern => "The string should have pattern '".concat(pattern, "'"),
  usingPlugin: fn => "The string should violate ".concat(fn.name || 'plugin')
};
function pluralify(num) {
  return num === 1 ? '' : 's';
}